import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppApiInterface } from 'src/app/app.api';
import { BaseService } from 'src/app/shared/services/base.service';
import { Member } from './member.model';

@Injectable({ providedIn: 'root' })
export class MembersService extends BaseService<Member>{
    constructor(
        protected injector:Injector,
    ){
        super(injector);

        this.copyJsonDataToObjectFunction=Member.fromJsonToObject
        this.urls={
            getAllUrl:'members',
            saveUrl:'regMembro',
            updateUrl:'up-membro',
            deleteUrl:'dst-membro',
            updateImageWithNoDataUrl:'up-membro-imagem'
        }
    }

}